import CookieStore from 'ember-simple-auth/session-stores/cookie';

import cookieDomain from 'qonto-switching-bank-js/utils/shared-cookie-domain';

export default CookieStore.extend({
  cookieDomain,
});
